import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-07016072"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "exhibitionItem"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  style: {
    "display": "none"
  }
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "type"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-exhibit"
}, null, -1));
const _hoisted_7 = {
  class: "number"
};
const _hoisted_8 = {
  key: 0,
  class: "exhibitonbottom"
};
const _hoisted_9 = {
  class: "exhibition-name"
};
const _hoisted_10 = {
  key: 0,
  class: "exhibition-address"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon-address"
}, null, -1));
const _hoisted_12 = {
  class: "number"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.exhibitions, item => {
    return _openBlock(), _createElementBlock("div", {
      onClick: $event => $options.showExhitonList(item),
      class: "exhibition"
    }, [_createElementVNode("div", _hoisted_3, _toDisplayString(item), 1), _createElementVNode("img", {
      class: "exhibition-img",
      src: item.images
    }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString($props.language ? item.exhibType : $options.getType(item.exhibType)), 1)]), $options.getName(item) !== '' && $options.getAddress(item) !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString($options.getName(item)), 1), $options.getAddress(item) !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString($options.getAddress(item)), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 8, _hoisted_2);
  }), 256))]);
}